import React, { useState } from "react";
import {
    Form,
    Input,
    Button,
} from "antd";
import {
    EyeInvisibleOutlined,
    EyeTwoTone,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import greenIcon from "../../assets/icons/bi_check-circle-fill.svg";
import "../../assets/css/forgot-password.css";
import { useSelector } from "react-redux";
import { authState } from "../../features/auth/authSlice";
import { confirmResetPassword } from 'aws-amplify/auth';


export default function ResetPassword() {

    const { resetPasswordEmail } = useSelector(authState);
    const [errorMessage, setErrorMessage] = useState("");

    const onFinish = async (values) => {
        if (values.new_password !== values.confirm_password) {
            setErrorMessage("Passwords do not match");
            return;
        }
        const { code, new_password } = values;
        try {
            await confirmResetPassword({ username: resetPasswordEmail, confirmationCode: code, newPassword: new_password });
        } catch (error) {
            setErrorMessage(error);
        }
    };

    return (
        <div className="container">
            <div className="head-text">Reset Password</div>
            <div className="lpass2-span">
                <img className="lpass2-span-img" src={greenIcon} alt="" />
                <div className="lpass2-span-text">
                    <b>Success</b> Password reset instructions have
                    <br />
                    been sent to {resetPasswordEmail}
                </div>
            </div>
            <div className="Email_Send_text">
                <p>
                    If the email doesn't show up ,Check your spam folder. We sent it
                    from <span>help@skillgigs.com</span>{" "}
                </p>
            </div>

            <Form name="forgot_password" className="login-form-lpass" onFinish={onFinish}>
                <div className="form-label">Code</div>
                <Form.Item
                    name="code"
                    className="new_pass_input"
                    rules={[
                        {
                            pattern: /^\d{6}$/,
                            message: "Enter valid code",
                        },
                        {
                            required: true,
                            message: "Please input code",
                        },
                    ]}
                >
                    <Input
                        maxLength="6"
                        autoComplete="new-password"
                        placeholder="OTP code"
                    />
                </Form.Item>
                <div className="form-label">New password</div>
                <Form.Item
                    name="new_password"
                    className="new_pass_input"
                    rules={[
                        {
                            pattern: /^\S{8,}$/,
                            message: "The input is not a valid Password",
                        },
                        {
                            required: true,
                            message: "Please input new password",
                        },
                    ]}
                >
                    <Input.Password
                        placeholder="New password"
                        autoComplete="new-password"
                        iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                    />
                </Form.Item>
                <div className="form-label">Confirm password</div>
                <Form.Item
                    name="confirm_password"
                    className="new_pass_input"
                    rules={[
                        {
                            required: true,
                            message: "Please confirm new password!",
                        },
                    ]}
                >
                    <Input placeholder="Confirm password" />
                </Form.Item>

                {errorMessage && <div className="lpass2-span-error">{errorMessage}</div>}
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button-lpass"
                    >
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
